import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase/config";

// Default attendance policy values
export const DEFAULT_ATTENDANCE_POLICY = {
  // Standard hours in a work day — the divisor for hourly rate / OT / undertime (C4).
  // This is the field's home; readers fall back to payrollRates only pre-backfill.
  hoursPerDay: 8,

  // Leeway settings
  leewayEarlyTimeIn: 30,
  leewayLateGracePeriod: 30,
  leewayOtStart: 30,
  leewayUndertimeGracePeriod: 30,

  // OT increment (floor rounding) — 0 = off, 15 = 15min blocks, 30 = 30min blocks
  otIncrement: 0,

  // OT auto-approval threshold (hours) — 0 = all OT requires manual approval
  otAutoApprovalThreshold: 0,

  // OT approval policy — 'self-approval' (maker may approve) | 'maker-checker' (maker blocked)
  otApprovalType: "self-approval",

  // Night differential window
  nightDiffStart: 22,
  nightDiffEnd: 6,
};

/**
 * Get attendance policy for a company.
 * Returns merged defaults + stored values.
 */
export const getAttendancePolicy = async (companyId) => {
  const policyDoc = await getDoc(
    doc(db, "companies", companyId, "settings", "attendancePolicy")
  );

  if (policyDoc.exists()) {
    return { ...DEFAULT_ATTENDANCE_POLICY, ...policyDoc.data() };
  }

  return { ...DEFAULT_ATTENDANCE_POLICY };
};

/**
 * Save attendance policy for a company.
 * Uses merge: true so partial updates are safe.
 */
export const saveAttendancePolicy = async (companyId, data) => {
  await setDoc(
    doc(db, "companies", companyId, "settings", "attendancePolicy"),
    {
      ...data,
      updatedAt: new Date(),
    },
    { merge: true }
  );
};
